import axiosClient from 'utils/axiosClient';
import api from 'api';
import {filterJSONData, formData} from 'utils/helpers/formData';

const getExams = async (role: 'STUDENT' | 'CANDIDATE') => {
	const API = api[role];

	const response = await axiosClient.get(API.USER.USER_EXAMS);
	return response.data;
};

const candidateById = async (id: number) => {
	const response = await axiosClient.get(api.CANDIDATE.USER.USER_BY_ID + id);
	return response.data;
};

const patchCandidate = async (data: any) => {
	data.residenceIsDifferentFromRegistration = data.residenceIsDifferentFromRegistration ?? false;
	const response = await axiosClient.patch(api.CANDIDATE.USER.USER_BY_ID, formData(data), {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
	return response.data;
};

const patchCandidateData = async (page: string, data: any, isDocument?: boolean) => {
	const options = page === 'documents' ? {headers: {'Content-Type': 'multipart/form-data'}} : undefined;
	if (page === 'personal') {
		data.residenceIsDifferentFromRegistration = data.residenceIsDifferentFromRegistration ?? false;
	}

	if (page === 'admission') {
		data.admissionFaculties = Array.isArray(data.admissionFaculties)
			? data.admissionFaculties
			: [data.admissionFaculties];
	}

	if (page === 'documents') {
		data.admissionFiles = data.admissionFiles?.filter(
			(file: {typeID: number; path?: File}) => !!file.path
		);
		data.admissionDuration = localStorage.getItem('time/admission');
	}

	const response = await axiosClient.patch(
		api.CANDIDATE.USER.USER_BY_ID + page,
		page === 'documents' ? formData(data) : filterJSONData(data, ['admissionLanguageExamID']),
		options
	);
	return response.data;
};

const getAdmissionData = async (role: 'STUDENT' | 'CANDIDATE', data?: any) => {
	const response = await axiosClient.get(api[role].USER.ADMISSION, data);

	if (role === 'STUDENT') {
		response.data.data.optionalSubjects = response.data.data.optionalSubjectData
			?.map((i: any) => i.name)
			.join(', ');
	}

	return response.data;
};

const getStudentApplications = async (data?: any) => {
	const response = await axiosClient.get(api.STUDENT.USER.APPLICATIONS, data);
	return response.data;
};

const createStudentApplication = async (data: any) => {
	const response = await axiosClient.post(
		api.STUDENT.USER.APPLICATIONS,
		data /* , {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	} */
	);
	return response.data;
};

const getProfile = async (role: 'STUDENT' | 'CANDIDATE', data?: any) => {
	const API = api[role];

	const response = await axiosClient.get(API.USER.PROFILE, data);
	return response.data;
};

const payOfflie = async (data: any) => {
	const response = await axiosClient.post(api.CANDIDATE.USER.PAY_OFFLINE, formData(data), {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
	return response.data;
};

const getPaymentLink = async () => {
	const response = await axiosClient.post(api.CANDIDATE.USER.GET_PAYMENT_LINK);
	return response.data;
};

const appealExam = async (data: any, role: 'STUDENT' | 'CANDIDATE') => {
	const API = api[role];

	const response = await axiosClient.post(API.USER.APPEAL, data);
	return response.data;
};

const getOpenInfo = async (data: any) => {
	const response = await axiosClient.get(
		`${api.CANDIDATE.USER.QR}?candidateID=${data.candidateID}&examID=${data.examID}`
	);
	return response.data;
};

const getStudentGroups = async (params?: any) => {
	const response = await axiosClient.get(api.STUDENT.USER.GROUPS, {params});
	return response.data;
};

const getSchedule = async (weekID: number) => {
	const response = await axiosClient.get(api.STUDENT.USER.SCHEDULE + weekID);
	return response.data;
};

const getLessonsWeek = async (params?: any) => {
	const response = await axiosClient.get(api.STUDENT.USER.LESSONS_WEEK);
	return response.data;
};

const getStudentCommands = async (params?: any) => {
	const response = await axiosClient.get(api.STUDENT.USER.COMMANDS);
	return response.data;
};

const getStudentSurveys = async (params?: any) => {
	const response = await axiosClient.get(api.STUDENT.USER.SURVEYS);
	return response.data;
};

const answerSurvey = async (surveyID: number, answers: any[]) => {
	const response = await axiosClient.post(api.STUDENT.USER.SURVEYS + '/' + surveyID, answers);
	return response.data;
};

const regToConsultation = async (examID: number) => {
	const response = await axiosClient.post(api.STUDENT.USER.CONSULTATION + examID);
	return response.data;
};

const checkDiplomaWork = async () => {
	const response = await axiosClient.get(api.STUDENT.USER.CHECK_DIPLOMA_WORK);
	return response.data;
};

const uploadDiplomaWork = async (data: any) => {
	const response = await axiosClient.patch(api.STUDENT.USER.UPLOAD_DIPLOMA_WORK, formData(data), {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
	return response.data;
};

const service = {
	getExams,
	candidateById,
	patchCandidate,
	getAdmissionData,
	getStudentApplications,
	createStudentApplication,
	payOfflie,
	getPaymentLink,
	appealExam,
	getOpenInfo,
	patchCandidateData,
	getProfile,
	getStudentGroups,
	getSchedule,
	getLessonsWeek,
	getStudentCommands,
	getStudentSurveys,
	answerSurvey,
	regToConsultation,
	checkDiplomaWork,
	uploadDiplomaWork
};

export default service;
